function initBlogFilterSlider() {
    const bfSlider = document.querySelector('[data-bf-slider]')
    const $tagTabs = document.querySelectorAll('[data-tag-wrapper]')

    if (!bfSlider || !$tagTabs.length) { return }

    $tagTabs.forEach(el => el.classList.remove('loading'))

    const spaceBetweenDesktop = document.querySelector('.bf__style--black') ? 2 : 20

    // new Swiper(bfSlider, {
    //     slidesPerView: 'auto',
    //     spaceBetween: 10,
    //     freeMode: true,
    //     mousewheel: {
    //       releaseOnEdges: true,
    //     },
    //     breakpoints: {
    //         1025: {
    //           spaceBetween: spaceBetweenDesktop,
    //         }
    //     }
    // })
    new Flickity('.bf__items', {
        cellAlign: 'left',
        pageDots: false,
        wrapAround: false,
        prevNextButtons: true,
        draggable: true
    })
}

function initBlogFilterSearch() {
    const $container = document.querySelector('[data-bf-search]')
    const $searchFormWrapper = $container.querySelector('[data-bf-search-form-wrapper]')
    console.log('1');
    if (!$container) { return }

    $container.classList.remove('loading')

    function initBlogFilterSearchOpen() {
        const $openBtn = $container.querySelector('[data-bf-search-open]')

        if (!$openBtn || !$searchFormWrapper) { return }

        $openBtn.addEventListener('click', (e) => {
            e.preventDefault()
            $searchFormWrapper.classList.add('open')
        })
    }

    function initBlogFilterSearchClose() {
        const $closeBtn = $container.querySelector('[data-bf-search-close]')

        if (!$closeBtn || !$searchFormWrapper) { return }

        $closeBtn.addEventListener('click', (e) => {
            e.preventDefault()
            $searchFormWrapper.classList.remove('open')
        })
    }
    console.log('2');

    initBlogFilterSearchOpen()
    initBlogFilterSearchClose()
}

window.addEventListener('DOMContentLoaded', (event) => {
    initBlogFilterSlider()
    initBlogFilterSearch()
})
$(window).on('load',function(e){
    new Flickity('.bf__items', {
        cellAlign: 'left',
        pageDots: false,
        wrapAround: false,
        prevNextButtons: true,
        draggable: true
    })
});